import { render, staticRenderFns } from "./LayoutWithHeader.vue?vue&type=template&id=8adf5624"
import script from "./LayoutWithHeader.vue?vue&type=script&lang=js"
export * from "./LayoutWithHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithHeader.vue?vue&type=style&index=0&id=8adf5624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports